import { AddDocument } from "@portal/BaseComponents/Activites/AddDocument/AddDocument";
import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import { TabItems } from "@portal/BaseComponents/Tab/type";
import { usePrivileges } from "@portal/hooks/use-privilleges";
import { usePageComponents } from "@portal/hooks/usePageComponents";
import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { usePageNavigate } from "@portal/lib/router/hooks/usePageNavigae";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";
import { useMatch, useParams } from "react-router-dom";
import { PortalTab } from "./style";
import { PORTAL_TABS, portalTabQueryKeys, portalTabsLabel } from "./types";

const tabs: PORTAL_TABS[number][] = [
  "INVOICES",
  "PAYMENTS",
  "DISPUTES",
  "CREDIT_NOTES",
  "PTPs",
  "DOCUMENTS",
  "PROFILE",
];
type RoutePathMatchConfig = Record<string, PORTAL_TABS[number]>;

export const matchConfig: RoutePathMatchConfig = {
  invoices: "INVOICES",
  payments: "PAYMENTS",
  "credit-notes": "CREDIT_NOTES",
  disputes: "DISPUTES",
  ptps: "PTPs",
  profile: "PROFILE",
  documents: "DOCUMENTS",
};
function PortalTabs() {
  const match = useMatch("/customers/:id/*");
  const navigate = usePageNavigate();
  const { getDocumentPrivileges } = usePrivileges();
  const [activeKey, setActiveKey] = useState<PORTAL_TABS[number]>(
    matchConfig[match?.params["*"]?.split("/")[0] ?? "invoices"]
  );
  const queryClient = useQueryClient();

  useEffect(() => {
    setActiveKey(matchConfig[match?.params["*"]?.split("/")[0] ?? "invoices"]);
  }, [match?.params]);
  const { pageComponents } = usePageComponents();
  const params = useParams<AppPageParams>();
  function getTabItems(): TabItems<PORTAL_TABS[number], string>[] {
    return tabs.map((tab) => {
      return {
        key: tab,
        label: portalTabsLabel[tab],
        children: pageComponents[tab],
      };
    });
  }

  function handleTableChange(activeKey: string) {
    const key = activeKey as PORTAL_TABS[number];
    setActiveKey(activeKey as PORTAL_TABS[number]);
    const queryKEY = portalTabQueryKeys[key];
    queryClient.invalidateQueries([queryKEY]);
    if (!params.customer_id) return;
    navigate({
      appPage: key,
      pathParams: {
        customer_id: params.customer_id,
      },
    });
  }

  const portalTabItems = useMemo(getTabItems, [pageComponents]);
  const isDocumentCreate = getDocumentPrivileges("DOCUMENT_CREATE");
  const Extra =
    activeKey === "DOCUMENTS" ? (
      <HideWrapper hide={!isDocumentCreate}>
        <AddDocument buttonProps={{ actionButton: true }} />
      </HideWrapper>
    ) : undefined;
  return (
    <PortalTab
      items={portalTabItems}
      activeKey={activeKey}
      onChange={handleTableChange}
      tabBarExtraContent={Extra}
    />
  );
}

export { PortalTabs };
